import React from 'react';
import { CheckCircle2, Clock, MoreHorizontal } from 'lucide-react';

const STATUS_ICON = {
  done:    { Icon: CheckCircle2, bg: 'bg-emerald-50',  border: 'border-emerald-200', text: 'text-emerald-600' },
  active:  { Icon: Clock,        bg: 'bg-sky-50',       border: 'border-sky-200',     text: 'text-sky-600'    },
  pending: { Icon: MoreHorizontal, bg: 'bg-slate-100', border: 'border-slate-200',   text: 'text-slate-400'  },
};

export function TimelineItem({ status = 'done', title, date, user, body, isLast = false }) {
  const { Icon, bg, border, text } = STATUS_ICON[status] || STATUS_ICON.done;
  return (
    <div className="flex gap-3 pb-4">
      <div className="flex flex-col items-center">
        <div className={`w-7 h-7 rounded-full ${bg} border-2 ${border} grid place-items-center ${text} flex-shrink-0`}>
          <Icon size={13} strokeWidth={2} />
        </div>
        {!isLast && <div className="w-px flex-1 bg-slate-200 mt-1" />}
      </div>
      <div className="pb-1 flex-1 min-w-0">
        <div className={`text-[13px] font-semibold ${status === 'pending' ? 'text-slate-400' : 'text-slate-900'}`}>
          {title}
        </div>
        {(date || user) && (
          <div className={`text-[11.5px] mt-0.5 flex gap-1.5 ${status === 'pending' ? 'text-slate-400' : 'text-slate-500'}`}>
            {date && <span>{date}</span>}
            {date && user && <span>·</span>}
            {user && <span>{user}</span>}
          </div>
        )}
        {body && (
          <div className="mt-1.5 bg-slate-50 border border-slate-200 rounded-md px-3 py-2 text-[12.5px] text-slate-600">
            {body}
          </div>
        )}
      </div>
    </div>
  );
}

export function Timeline({ items = [] }) {
  return (
    <div className="space-y-0">
      {items.map((item, i) => (
        <TimelineItem key={i} {...item} isLast={i === items.length - 1} />
      ))}
    </div>
  );
}

export default Timeline;
